export enum MulticupSystems {
  LEGACY = 'old',
  EE_ALMERA = 'ee_almera',
  EE_KOZ = 'ee_koz',
  SDC = 'sdc',
  EE_DFWC = 'ee_dfwc',
}
